import React, { FC } from 'react';
import { Notification } from '@wix/design-system';
import { useTranslation } from '@wix/fe-essentials-standalone';

type ReportTemplateErrorNotificationProps = {
  showReportTemplateError: boolean;
  onSubmit: () => void;
  setShowReportTemplateError: (show: boolean) => void;
};

const ReportTemplateErrorNotification: FC<
  ReportTemplateErrorNotificationProps
> = ({ showReportTemplateError, onSubmit, setShowReportTemplateError }) => {
  const { t } = useTranslation();

  return (
    <Notification
      type="sticky"
      theme="error"
      show={showReportTemplateError}
      dataHook="brief-page-error-message"
      zIndex={4}
    >
      <Notification.TextLabel
        maxLines={1}
        appendTo="viewport"
        maxWidth="100%"
        size="medium"
        textAlign="start"
        fixed
      >
        {t('marketplace.template-page.report-template-error')}
      </Notification.TextLabel>
      <Notification.ActionButton onClick={async () => await onSubmit()}>
        {t('marketplace.template-page.report-template-error-try-again-cta')}
      </Notification.ActionButton>
      <Notification.CloseButton
        onClick={() => setShowReportTemplateError(false)}
      />
    </Notification>
  );
};

export default ReportTemplateErrorNotification;
